import React from 'react';
import styles from './index.module.scss';

function Icon({ icon, text }) {
    return (
        <>
            <i className={`p-button-icon p-button-icon-left pi ${icon}`}></i>
            <span className={styles.icon}>{text}</span>
        </>
    );
}

export default function LabelFile({ name, icon, text, fileName, disabled }) {
    return (
        <label
            type="button"
            htmlFor={!disabled ? name : null}
            className={`p-button w-20rem ${disabled ? styles.hasDisable : ''}`}
            label="Carregar"
        >
            <strong>
                <Icon icon={icon} text={text} />
                {fileName && (
                    <span
                        className={styles.inputLabel}
                        style={{
                            width: fileName.length > 21 ? '70%' : '55%',
                        }}
                    >
                        <i className="p-button-icon p-button-icon-left pi pi-file"></i>
                        {fileName.length > 15
                            ? `${fileName.substring(0, 15)}... ${fileName.substring(
                                  fileName.indexOf('.'),
                                  fileName.length
                              )}`
                            : fileName}
                    </span>
                )}
            </strong>
        </label>
    );
}
